/**
 * Admin Feature - Composition and Export Root
 * @module app/admin
 */

// XLSXSpreadsheet is a subclass of Spreadsheet
//
// Both of these classes are "services" that we create instances of
// here and pass to the relevant consumers.
//
// We do this to make testing "easier" (because IoC), and also
// to allow completely changing whatever implementation of
// external spreadsheet-parsing + remote storage libraries we're using.
import { XLSXSpreadsheet } from './lib'

// uploadWhitelistApi is a factory function that returns an Api service object
// which needs to know about Spreadsheet and Storage services
import uploadWhitelistApi from './api'

// uploadWhitelistSaga is a factory function that returns a function to start admin
// related sagas. Itneeds to know about the Api service
import UploadWhitelistSaga from './sagas'

// Create the real service instances
const Api = uploadWhitelistApi({
    Spreadsheet: XLSXSpreadsheet
})

// uploadWhitelistSaga should be imported into whichever module defines the root
// saga (ie. the application-level composition root)
export const uploadWhitelistSaga = UploadWhitelistSaga({ Api })

// uploadWhitelistReducer needs to be passed to whichever module defines
// the root reducer (again, the composition root)
export { default as uploadWhitelistReducer } from './reducer'

// UploadWhitelistContainer is our entry component that (in our case) mounted
// to a Route component
export { UploadWhitelistContainer } from './containers'
